import { SSO_SETTINGS, SSO_LOGIN_URL, SSO_LOGOUT_URL, SSO_CHECK_SESSION_URL } from './constants';
import store from '../store';
import 'whatwg-fetch';

export function ssoLogin() {
	const state = store.getState();
	var current_url = window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search;
	// var locale = 'en-SG';
	let locale = state.data.language?(state.data.language.locale?state.data.language.locale:'en-SG'):'en-SG';
	var redirect_params = 'app_id=' + SSO_SETTINGS['app_id'].toString() + '&redirect_uri=' + encodeURIComponent(current_url) + '&locale=' + locale;
	window.location = SSO_LOGIN_URL + '?' + redirect_params;
}

export function ssoLogout(sessionKey, uid) {
	var redirect_params = 'app_id=' + SSO_SETTINGS['app_id'].toString() + '&redirect_uri=' + logoutRedirectUri() + '&session_key=' + sessionKey + '&uid=' + uid;
	window.location = SSO_LOGOUT_URL + '?' + redirect_params;
}

export function logoutRedirectUri() {
	const state = store.getState();
	let locale = state.data.language ? (state.data.language.locale?state.data.language.locale:'en-SG') : 'en-SG';
	var redirect_params = 'app_id=' + SSO_SETTINGS['app_id'].toString() + '&redirect_uri=' + encodeURIComponent(window.location.origin + '/') + '&locale=' + locale;
    return SSO_LOGIN_URL + '?' + redirect_params;
}

export const getFetchOptions = (method: string, extraHeaders: ?Object) => ({
  method,
  mode: 'cors',
  credentials: 'include',
  headers: Object.assign(
    {},
    method === 'GET'
      ? {
          accept: 'application/json',
        }
      : {
          accept: 'application/json',
          'content-type': 'application/json',
        },
    extraHeaders
  ),
});

export function ssoCheckSession() {
    return fetch(SSO_CHECK_SESSION_URL + '?' + 'app_id=' + SSO_SETTINGS['app_id'].toString(), {
        ...getFetchOptions('GET')
    });
}



// WEBPACK FOOTER //
// ./app/api.js